// WITHIN-client accounts are created with payments disabled: creators are contracted and paid through Wrapbook,
// so brkfst never pays them or charges the brand. The flag is set once at account creation and is read-only after.

export const PAYMENTS_DISABLED_OPTION = {
  ENABLED: 'false',
  DISABLED: 'true',
} as const;

export type PaymentsDisabledOption = (typeof PAYMENTS_DISABLED_OPTION)[keyof typeof PAYMENTS_DISABLED_OPTION];

export const PAYMENTS_DISABLED_OPTIONS: { value: PaymentsDisabledOption; label: string }[] = [
  { value: PAYMENTS_DISABLED_OPTION.ENABLED, label: 'Through brkfst' },
  { value: PAYMENTS_DISABLED_OPTION.DISABLED, label: 'External — Wrapbook (WITHIN client)' },
];

// Accounts load asynchronously and useAccounts returns {} until they do, so anything missing means payments enabled.
export const isPaymentsDisabled = (account?: { paymentsDisabled?: boolean } | null): boolean =>
  !!account?.paymentsDisabled;

export const toPaymentsDisabled = (value?: string | null): boolean => value === PAYMENTS_DISABLED_OPTION.DISABLED;

export const paymentsDisabledLabel = (account?: { paymentsDisabled?: boolean } | null): string =>
  isPaymentsDisabled(account) ? PAYMENTS_DISABLED_OPTIONS[1].label : PAYMENTS_DISABLED_OPTIONS[0].label;
